import { DotLegalDialog, DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../../localization/useTranslation";
import React from "react";
import { EvaluationStatus, EvaluationStatusSaveModel } from "./EvaluateQuestionnaireDialog.types";
import useEvaluateQuestionnaireDialogHooks from "./EvaluateQuestionnaireDialog.hooks";
import EvaluationQuestionnaireContent from "./evaluationQuestionnaireContent/EvaluationQuestionnaireContent.tsx";

export interface IEvaluateQuestionnaireDialog {
    onDialogClose: () => void;
    onOkClick: (saveModel: EvaluationStatusSaveModel) => void;
    header: string;
    info: string;
    isSaving: boolean;
    evaluation: string | undefined;
    evaluationStatus: EvaluationStatus | undefined;
}

function EvaluateQuestionnaireDialog(props: IEvaluateQuestionnaireDialog) {
    const { translateString } = useTranslation();
    const { evaluationStatusUpdater, evaluation, onSaveClick } = useEvaluateQuestionnaireDialogHooks(props);

    return (
        <DotLegalDialog
            inProgress={props.isSaving}
            header={props.header}
            buttonOkText={translateString("save")}
            size="md"
            open
            onDialogClose={props.onDialogClose}
            onOkClick={onSaveClick}
        >
            <EvaluationQuestionnaireContent
                evaluationStatus={evaluation.evaluationStatus}
                evaluation={evaluation.evaluation}
                onEvaluationStateChange={(status) => evaluationStatusUpdater.onStatusChange(status)}
                onEvaluationChange={evaluationStatusUpdater.onEvaluationChange}
                info={props.info}
            />
        </DotLegalDialog>
    );
}

export default EvaluateQuestionnaireDialog;
